// Runtime environment label (prod / dev / sandbox). Set per Vercel project
// via VITE_APP_ENV. Distinct from VERCEL_ENV — both the prod and sandbox
// admin projects deploy as VERCEL_ENV=production, so we need our own label.

export type AppEnv = 'prod' | 'dev' | 'sandbox';

const VALID_APP_ENVS: readonly AppEnv[] = ['prod', 'dev', 'sandbox'];

const raw = (import.meta.env.VITE_APP_ENV ?? 'prod').toString().trim().toLowerCase();
if (!VALID_APP_ENVS.includes(raw as AppEnv)) {
  throw new Error(
    `VITE_APP_ENV must be one of ${VALID_APP_ENVS.join(', ')} (got "${raw}")`
  );
}

export const APP_ENV: AppEnv = raw as AppEnv;

export const isProd = () => APP_ENV === 'prod';
export const isSandbox = () => APP_ENV === 'sandbox';
export const isDev = () => APP_ENV === 'dev';

// True when the app is being served from the developer's machine. Distinct
// from isDev() — local `.env` ships with VITE_APP_ENV=prod, so env-based
// checks won't catch "running pnpm dev locally". Use this to gate dev-only
// affordances (e.g. manual Booqable sync buttons) regardless of env label.
export const isLocalhost = () =>
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
